module.exports = __webpack_public_path__ + "img/Boss-1.4f3d7f28.png";